import { fetchSettingsStatus, saveSettings } from '../../api/settings';
import { fetchSymbols } from '../../api/futures';
import { profileStore } from './profile.store.svelte';

const DEFAULT_SYMBOLS = ['SOLUSDT', 'BTCUSDT', 'ETHUSDT', 'BNBUSDT', 'XRPUSDT', 'DOGEUSDT'];

export default class Profile {
    async getStatus(): Promise<boolean> {
        try {
            const data = await fetchSettingsStatus();
            profileStore.hasKeys = data.hasKeys;
            return data.hasKeys;
        } catch {
            return false;
        }
    }

    async saveSettings(): Promise<void> {
        try {
            await saveSettings(profileStore.apiKey, profileStore.secretKey);
            profileStore.editing = false;
            profileStore.hasKeys = true;
        } catch {
            alert('Помилка збереження налаштувань.');
        }
    }

    async getSymbols(): Promise<string[]> {
        try {
            const data = await fetchSymbols();
            return data.status === 'success' ? data.symbols : DEFAULT_SYMBOLS;
        } catch {
            return DEFAULT_SYMBOLS;
        }
    }
}
